var master = "https://2tlsxxdjw3.execute-api.ap-south-1.amazonaws.com/dev/api/"  //master
// var admin = "https://o4bnlyt5f7.execute-api.ap-south-1.amazonaws.com/dev/api/" //admin 

var admin = "https://xklsdonvbl.execute-api.ap-south-1.amazonaws.com/dev/api/"            //hoardings-api 

var local = "http://localhost:3000/dev/api/"   //local
var eticketadmin = "https://7s7yk7ml15.execute-api.ap-south-1.amazonaws.com/dev/api/" //eticket
var track_api = "https://5xuckm290e.execute-api.ap-south-1.amazonaws.com/dev/api/"    // track_api

import axios from 'axios'
var header = {
    headers: {
        "Content-Type": "application/json"
    }
};
export default {
    dashboarddatausagereport(data) {
        return axios.post(master + "Data/datausagereport", JSON.stringify(data), header)
    },
    todayslecturereport(data) {
        return axios.post(master + "Data/todayslecturesadmindashboard", JSON.stringify(data), header)
    },
    teacherlecturereportadmin() {
        return axios.post(master + "Data/teacherlecturereportadmin", '', header)
    },
    dashboardcount(data) {
        return axios.post(admin + "master/GetDashboardDetails", JSON.stringify(data), header)
    },
    networkconnectivityreport(data) {
        return axios.post(master + "Data/networkconnectivityreport", JSON.stringify(data), header)
    },
    login(data) {
        return axios.post(master + "data/login", JSON.stringify(data), header) //master
    },
    getUserQueriesComments(data) {
        return axios.post(master + "Data/getUserQueriesComments", JSON.stringify(data), header)
    },
    saveUserComment(data) {
        return axios.post(master + "Data/saveUserComment", JSON.stringify(data), header)
    },
    teacherlistdropdown() {
        return axios.post(master + "Data/teacherlistdropdown", '', header)
    },
    assignUserQuery(data) {
        return axios.post(master + "Data/assignUserQuery", JSON.stringify(data), header)
    },
    //news master
    newslist(data) {
        return axios.post(master + "Data/newsmaster", JSON.stringify(data), header)
    },
    editnewsmaster(data) {
        return axios.post(master + "Admin/newsedit", JSON.stringify(data), header)
    },
    addnewsmaster(data) {
        return axios.post(master + "Admin/newsadd", JSON.stringify(data), header)
    },
    deletenewsmaster(data) {
        return axios.post(master + "Admin/newsdelete", JSON.stringify(data), header)
    },
    //video master
    videolist(data) {
        return axios.post(master + "Data/videomaster", JSON.stringify(data), header)
    },
    editvideomaster(data) {
        return axios.post(master + "Admin/videoedit", JSON.stringify(data), header)
    },
    addvideomaster(data) {
        return axios.post(master + "Admin/videoadd", JSON.stringify(data), header)
    },
    deletevideomaster(data) {
        return axios.post(master + "Admin/videodelete", JSON.stringify(data), header)
    },
    //schemes master
    schemelist(data) {
        return axios.post(master + "Data/schemesmaster", JSON.stringify(data), header)
    },
    editschememaster(data) {
        return axios.post(master + "Admin/schemeedit", JSON.stringify(data), header)
    },
    addschememaster(data) {
        return axios.post(master + "Admin/schemeadd", JSON.stringify(data), header)
    },
    deleteschememaster(data) {
        return axios.post(master + "Admin/schemedelete", JSON.stringify(data), header)
    },
    //Government master
    governmentlist(data) {
        return axios.post(master + "Data/governmentmaster", JSON.stringify(data), header)
    },
    editgovernmentmaster(data) {
        return axios.post(master + "Admin/govedit", JSON.stringify(data), header)
    },
    addgovernmentmaster(data) {
        return axios.post(master + "Admin/govadd", JSON.stringify(data), header)
    },
    deletegovernmentmaster(data) {
        return axios.post(master + "Admin/govdelete", JSON.stringify(data), header)
    },
    //query master
    querylist(data) {
        return axios.post(master + "Data/QueryTypeList", JSON.stringify(data), header)
    },
    editquerymaster(data) {
        return axios.post(master + "Admin/querytypeedit", JSON.stringify(data), header)
    },
    addquerymaster(data) {
        return axios.post(master + "Admin/querytypeadd", JSON.stringify(data), header)
    },
    deletequerymaster(data) {
        return axios.post(master + "Admin/querytypedelete", JSON.stringify(data), header)
    },
    //subquery master
    subquerylist(data) {
        return axios.post(master + "Data/getQuerySubTypesList", JSON.stringify(data), header)
    },
    editsubquerymaster(data) {
        return axios.post(master + "Admin/subquerytypeedit", JSON.stringify(data), header)
    },
    addsubquerymaster(data) {
        return axios.post(master + "Admin/subquerytypeadd", JSON.stringify(data), header)
    },
    deletesubquerymaster(data) {
        return axios.post(master + "Admin/subquerytypedelete", JSON.stringify(data), header)
    },
    //syllabus master
    syllabuslist(data) {
        return axios.post(master + "Data/syllabusmaster", JSON.stringify(data), header)
    },
    editsyllabusmaster(data) {
        return axios.post(master + "Admin/syllabusedit", JSON.stringify(data), header)
    },
    addsyllabusmaster(data) {
        return axios.post(master + "Admin/syllabusadd", JSON.stringify(data), header)
    },
    deletesyllabusmaster(data) {
        return axios.post(master + "Admin/syllabusdelete", JSON.stringify(data), header)
    },
    //subject master
    subjectlist(data) {
        return axios.post(master + "Data/subjectlistmaster", JSON.stringify(data), header)
    },
    editsubjectmaster(data) {
        return axios.post(master + "Admin/subjectedit", JSON.stringify(data), header)
    },
    addsubjectmaster(data) {
        return axios.post(master + "Admin/subjectadd", JSON.stringify(data), header)
    },
    deletesubjectmaster(data) {
        return axios.post(master + "", JSON.stringify(data), header)
    },
    //batch master
    batchlist(data) {
        return axios.post(master + "Data/batchlistmaster", JSON.stringify(data), header)
    },
    editbatchmaster(data) {
        return axios.post(master + "Admin/batchedit", JSON.stringify(data), header)
    },
    addbatchmaster(data) {
        return axios.post(master + "Admin/batchadd", JSON.stringify(data), header)
    },
    deletebatchmaster(data) {
        return axios.post(master + "", JSON.stringify(data), header)
    },
    //year master
    yearlist(data) {
        return axios.post(master + "Data/yearlistmaster", JSON.stringify(data), header)
    },
    edityearmaster(data) {
        return axios.post(master + "Admin/yearedit", JSON.stringify(data), header)
    },
    addyearmaster(data) {
        return axios.post(master + "Admin/yearadd", JSON.stringify(data), header)
    },
    deleteyearmaster(data) {
        return axios.post(master + "", JSON.stringify(data), header)
    },
    //student master
    studentlist(data) {
        return axios.post(master + "data/studentlist", JSON.stringify(data), header)
    },
    editstudentmaster(data) {
        return axios.post(master + "Data/studentedit", JSON.stringify(data), header)
    },
    addstudentmaster(data) {
        return axios.post(master + "Data/studentadd", JSON.stringify(data), header)
    },
    deletestudentmaster(data) {
        return axios.post(master + "Data/studentdelete", JSON.stringify(data), header)
    },
    //get district  Data/districtlistmaster
    getdistrictmaster(data) {
        return axios.post(master + "Data/districtlistmaster", JSON.stringify(data), header)
    },
    //get cat  
    getcatmaster(data) {
        return axios.post(master + "data/castlistmaster", JSON.stringify(data), header)
    },
    //get std doc list
    getdocmaster(data) {
        return axios.post(master + "Admin/getstudentdocuments", JSON.stringify(data), header)
    },
    //assstudent master
    assstudentlist(data) {
        return axios.post(master + "AssTeacher/studentmaster", JSON.stringify(data), header)
    },
    //resetpassword  //Admin/resetpassword
    
    //uploadstudentdocuments
    uploadstudentdocuments(data) {
        return axios.post(master + "Admin/uploadstudentdocuments", JSON.stringify(data), header)
    },
    //assteacher master
    assteacherlist(data) {
        return axios.post(master + "data/assteacherlist", JSON.stringify(data), header)
    },
    editassteachermaster(data) {
        return axios.post(master + "Admin/teacheredit", JSON.stringify(data), header)
    },
    addassteachermaster(data) {
        return axios.post(master + "Admin/teacheradd", JSON.stringify(data), header)
    },
    deleteassteachermaster(data) {
        return axios.post(master + "Admin/teacherdelete", JSON.stringify(data), header)
    },
    assprofiledetails(data) {
        return axios.post(master + "AssTeacher/profiledetails", JSON.stringify(data), header)
    },
    //teacher master
    teacherlist(data) {
        return axios.post(master + "data/teacherlist", JSON.stringify(data), header)
    },
    editteachermaster(data) {
        return axios.post(master + "Admin/teacheredit", JSON.stringify(data), header)
    },
    addteachermaster(data) {
        return axios.post(master + "Admin/teacheradd", JSON.stringify(data), header)
    },
    deleteteachermaster(data) {
        return axios.post(master + "Admin/teacherdelete", JSON.stringify(data), header)
    },
    //Previous lecture
    previouslecture(data) {
        return axios.post(master + "AssTeacher/previouslecture", JSON.stringify(data), header)
    },
    lectureattendedstudentlist(data) {
        return axios.post(master + "AssTeacher/lectureattendedstudentlist", JSON.stringify(data), header)
    },
    uploadtchdetails(data) {
        return axios.post(master + "AssTeacher/uploadtchdetails", JSON.stringify(data), header)
    },
    uploadFile(data) {
        //return axios.post('https://localhost:44336/api/PreSignedUrl/', data,  header)
        return axios.post(master + "Fileupload/geturl", data, header)
    },
    //user master
    userlist(data) {
        return axios.post(master + "data/adminuserlistmaster", JSON.stringify(data), header)
    },
    editusermaster(data) {
        return axios.post(master + "Admin/adminedit", JSON.stringify(data), header)
    },
    addusermaster(data) {
        return axios.post(master + "Admin/adminadd", JSON.stringify(data), header)
    },
    deleteusermaster(data) {
        return axios.post(master + "Admin/admindelete", JSON.stringify(data), header)
    },
    //send notification
    pushnotificationlistmaster(data) {
        return axios.post(master + "data/pushnotificationlistmaster", JSON.stringify(data), header)
    },
    sendpushnotification(data) {
        return axios.post(master + "Data/sendpushnotification", JSON.stringify(data), header)
    },
    // notification config
    pushnotificationconfigurationmaster(data) {
        return axios.post(master + "data/pushnotificationconfigurationmaster", JSON.stringify(data), header)
    },
    editpushnotificationconfigurationmaster(data) {
        return axios.post(master + "Admin/pncedit", JSON.stringify(data), header)
    },
    addpushnotificationconfigurationmaster(data) {
        return axios.post(master + "Admin/pncadd", JSON.stringify(data), header)
    },
    deletepushnotificationconfigurationmaster(data) {
        return axios.post(master + "Admin/pncdelete", JSON.stringify(data), header)
    },
    //ass student submission
    studentsubmissiondropdown(data) {
        return axios.post(master + "AssTeacher/studentsubmissiondropdown", JSON.stringify(data), header)
    },
    studentsubmissionassignments(data) {
        return axios.post(master + "AssTeacher/studentsubmissionassignments", JSON.stringify(data), header)
    },
    updateteacherremark(data) {
        return axios.post(master + "AssTeacher/updateteacherremark", JSON.stringify(data), header)
    },
    //admin student assigment
    adminstudentsubmissionassignments(data) {
        return axios.post(master + "AssTeacher/studentsubmissionassignments", JSON.stringify(data), header)
    },
    //teacher assigment
    teacherstudentsubmissionassignments(data) {
        return axios.post(master + "AssTeacher/studentsubmissionassignments", JSON.stringify(data), header)
    },
    //studymaterial admin
    studymaterialmaster(data) {
        return axios.post(master + "Admin/studymaterialmaster", JSON.stringify(data), header)
    },
    subjectwisetopiclist(data) {
        return axios.post(master + "Admin/subjectwisetopiclist", JSON.stringify(data), header)
    },
    //recordings
    recordingmaster(data) {
        return axios.post(master + "Data/recordingmaster", JSON.stringify(data), header)
    },
    getcourceteacherlist(data) {
        return axios.post(master + "Admin/getcourceteacherlist", JSON.stringify(data), header)
    },
    recordingadd(data) {
        return axios.post(master + "Admin/recordingadd", JSON.stringify(data), header)
    },
    recordingedit(data) {
        return axios.post(master + "Admin/recordingedit", JSON.stringify(data), header)
    },
    //librarymaster
    librarymaster(data) {
        return axios.post(master + "Data/librarymaster", JSON.stringify(data), header)
    },
    //today lecture
    todaylectureadminmaster(data) {
        return axios.post(master + "Data/todaylectureadminmaster", JSON.stringify(data), header)
    },
    schedulelecturelist(data) {
        return axios.post(master + "Admin/schedulelecturelist", JSON.stringify(data), header)
    },
    schedulelectureview(data) {
        return axios.post(master + "Admin/schedulelectureview", JSON.stringify(data), header)
    },
    teachersubjects(data) {
        return axios.post(master + "Admin/teachersubjects", JSON.stringify(data), header)
    },
    getsubjecttopic(data) {
        return axios.post(master + "Admin/getsubjecttopic", JSON.stringify(data), header)
    },
    schedulelectureedit(data) {//
        return axios.post(master + "Admin/schedulelectureedit", JSON.stringify(data), header)
    },
    schedulelectureadd(data) {//
        return axios.post(master + "Admin/schedulelectureadd", JSON.stringify(data), header)
    },
    schedulelectureliveadd(data) {//Admin/schedulelectureliveadd
        return axios.post(master + "Admin/schedulelectureliveadd", JSON.stringify(data), header)
    },
    schedulelectureliveedit(data) {//Admin/schedulelectureliveedit
        return axios.post(master + "Admin/schedulelectureliveedit", JSON.stringify(data), header)
    },
    //student Device registration   
    stdentregistrationlist(data) {
        return axios.post(master + "Data/stdentregistrationlist", JSON.stringify(data), header)
    },
    //content creation  
    contentcreationlist(data) {
        return axios.post(master + "AssTeacher/contentcreationlist", JSON.stringify(data), header)
    },
    //upcomming lecture admin  
    upcominglectures(data) {
        return axios.post(master + "Admin/upcominglectures", JSON.stringify(data), header)
    },
    //ask doubt admin  
    askdoubtreport(data) {
        return axios.post(master + "Admin/askdoubtreport", JSON.stringify(data), header)
    },
    viewdoubt(data) {
        return axios.post(master + "Admin/viewdoubt", JSON.stringify(data), header)
    },
    //ask doubt teacher  
    answedoubt(data) {
        return axios.post(master + "Admin/answedoubt", JSON.stringify(data), header)
    },
    //admin report
    studentlis(data) {
        return axios.post(master + "Data/studentlist", JSON.stringify(data), header)
    },
    adminlectureviewreport(data) {
        return axios.post(master + "Admin/adminlectureviewreport", JSON.stringify(data), header)
    },
    adminteacherlecreport(data) {
        return axios.post(master + "Admin/adminteacherlecreport", JSON.stringify(data), header)
    },
    //mocktest admin
    mocktestlistmaster(data) {
        return axios.post(master + "Data/mocktestlistmaster", JSON.stringify(data), header)
    },
    mocktestadd(data) {//Admin/mocktestadd
        return axios.post(master + "Admin/mocktestadd", JSON.stringify(data), header)
    },
    mocktestedit(data) {//Admin/mocktestedit
        return axios.post(master + "Admin/mocktestedit", JSON.stringify(data), header)
    },
    mockteststudentlist(data) {
        return axios.post(master + "Admin/mockteststudentlist", JSON.stringify(data), header)
    },
    //test result
    TestDateList(data) {
        return axios.post(master + "Data/TestDateList", JSON.stringify(data), header)
    },
    TopTenTestResultListAllSubject(data) {
        return axios.post(master + "Data/TopTenTestResultListAllSubject", JSON.stringify(data), header)
    },
    subjecttestdetails(data) {
        return axios.post(master + "Data/subjecttestdetails", JSON.stringify(data), header)
    },
    //manage live class
    manageliveclasslist(data) {
        return axios.post(master + "AssTeacher/manageliveclasslist", JSON.stringify(data), header)
    },
    cancellecture(data) {
        return axios.post(master + "AssTeacher/cancellecture", JSON.stringify(data), header)
    },
    //dropdown user query master
    helpdesknetworkusersdropdown() {
        return axios.post(master + "Data/helpdesknetworkusersdropdown", '', header)
    },
    //today lecture teacher
    todayslectures(data) {
        return axios.post(master + "Teacher/todayslectures", JSON.stringify(data), header)
    },
    //network user master
    helpdesknetworkusersmaster(data) {
        return axios.post(master + "Data/helpdesknetworkusersmaster", JSON.stringify(data), header)
    },
    helpdesknetworkuseradd(data) {//
        return axios.post(master + "Admin/helpdesknetworkuseradd", JSON.stringify(data), header)
    },
    helpdesknetworkuseredit(data) {//
        return axios.post(master + "Admin/helpdesknetworkuseredit", JSON.stringify(data), header)
    },
    helpdesknetworkuserdelete(data) {//Admin/helpdesknetworkuserdelete
        return axios.post(master + "Admin/helpdesknetworkuserdelete", JSON.stringify(data), header)
    },
    practicepaperslist(data) {//
        return axios.post(master + "data/practicepaperslist", JSON.stringify(data), header)
    },
    PracticePaperList(data) {//student
        return axios.post(master + "data/PracticePaperList", JSON.stringify(data), header)
    },
    dashboarddata(data) {//
        return axios.post(master + "Admin/dashboarddata", JSON.stringify(data), header)
    },
    dashboarddataleaderboards(data) {//
        return axios.post(master + "Admin/dashboarddataleaderboards", JSON.stringify(data), header)
    },
    todaysassignmentupload(data) {//
        return axios.post(master + "Admin/todaysassignmentupload", JSON.stringify(data), header)
    },
    dashboarddataA(data) {//
        return axios.post(master + "AssTeacher/dashboarddata", JSON.stringify(data), header)
    },
    //JEE / NEET upload test:
    testpapersmaster(data) {//
        return axios.post(master + "Data/testpapersmaster", JSON.stringify(data), header)
    },
    testadd(data) {//Data/testadd
        return axios.post(master + "Admin/testadd", JSON.stringify(data), header)
    },
    testedit(data) {//Data/testedit
        return axios.post(master + "Admin/testedit", JSON.stringify(data), header)
    },
    testdelete(data) {//Data/testdelete
        return axios.post(master + "Admin/testdelete", JSON.stringify(data), header)
    },
    //notice
    noticelistmaster(data) {//Data/testdelete
        return axios.post(master + "Data/noticelistmaster", JSON.stringify(data), header)
    },
    noticeadd(data) {//Admin/noticeadd
        return axios.post(master + "Admin/noticeadd", JSON.stringify(data), header)
    },
    noticeedit(data) {//Admin/noticeedit
        return axios.post(master + "Admin/noticeedit", JSON.stringify(data), header)
    },
    connectivityreport1(data) {//Admin/noticeedit
        return axios.post(master + "Admin/connectivityreport1", JSON.stringify(data), header)
    },
    connectivityreport2(data) {//Admin/connectivityreport2
        return axios.post(master + "Admin/connectivityreport2", JSON.stringify(data), header)
    },
    studentsubjectlist(data) {//Data/subjectlist
        return axios.post(master + "Data/subjectlist", JSON.stringify(data), header)
    },
    studentlibrarydata(data) {//Data/subjectlist
        return axios.post(master + "Data/library", JSON.stringify(data), header)
    },
    devicelist(data) {
        return axios.post(master + "Data/devicelist", JSON.stringify(data), header)
    },
    deviceinfo(data) {
        return axios.post(master + "Data/deviceinfo", JSON.stringify(data), header)
    },
    devicereboot(data) {
        return axios.post(master + "Data/devicereboot", JSON.stringify(data), header)
    },
    //approval api
    ApplicationList(data) {
        return axios.post(master + "data/AdminApplicationList", JSON.stringify(data), header)
    },
    ReadRejectReason(data) {
        return axios.post(master + "data/ReadRejectReason", JSON.stringify(data), header)
    },
    RoleStatusMappingByAppStatus(data) {
        return axios.post(master + "data/RoleStatusMappingByAppStatus", JSON.stringify(data), header)
    },
    ApplicationApproval(data) {
        return axios.post(master + "data/ApplicationApproval", JSON.stringify(data), header)
    },
    ApplicationLogHistory(data) {
        return axios.post(master + "data/ApplicationLogHistory", JSON.stringify(data), header) //master
    },
    schemelist(data) {
        return axios.post(master + "data/AdminSchemeList", JSON.stringify(data), header)
    },
    Addschememaster(data) {
        return axios.post(master + "data/AddScheme", JSON.stringify(data), header)
    },
    Editchememaster(data) {
        return axios.post(master + "data/EditScheme", JSON.stringify(data), header)
    },
    Deletescheme(data) {
        return axios.post(master + "data/schemedelete", JSON.stringify(data), header)
    },
    batchlist(data) {
        return axios.post(master + "data/AdminBatchList", JSON.stringify(data), header)
    },
    Addbatchmaster(data) {
        return axios.post(master + "data/AddBatch", JSON.stringify(data), header)
    },
    Editbatchmaster(data) {
        return axios.post(master + "data/EditBatch", JSON.stringify(data), header)
    },
    Deletebatch(data) {
        return axios.post(master + "data/Batchdelete", JSON.stringify(data), header)
    },
    schemeDropdown(data) {
        return axios.post(master + "data/schemedropdown", JSON.stringify(data), header)
    },
    GetApplicationTemp(data) {
        return axios.post(admin + "scheme/ApplicationTemp", JSON.stringify(data), header) //admin
    },
    // notification API
    notificationList(data) {
        return axios.post(master + "notification/AdminNotificationList ", JSON.stringify(data), header)
    },
    addNotification(data) {
        return axios.post(master + "notification/AdminAddNotification ", JSON.stringify(data), header)
    },
    editNotification(data) {
        return axios.post(master + "notification/AdminEditNotification ", JSON.stringify(data), header)
    },
    deleteNotification(data) {
        return axios.post(master + "notification/AdminDeleteNotification ", JSON.stringify(data), header)
    },
    HoardingDropdownList(data) {
        return axios.post(master + "notification/HoardingDropdownList ", JSON.stringify(data), header)
    },
    UserDropdownList(data) {
        return axios.post(master + "notification/UserDropdownList ", JSON.stringify(data), header)
    },
    StateList(data) {
        return axios.post(master + "notification/StateList ", JSON.stringify(data), header)
    },
    DistrictList(data) {
        return axios.post(master + "notification/DistrictList ", JSON.stringify(data), header)
    },
    MuncipalCorporationList(data) {
        return axios.post(master + "notification/MuncipalCorporationList ", JSON.stringify(data), header)
    },
    AdminHoardingMasterList(data) {
        return axios.post(master + "notification/AdminHoardingMasterList2 ", JSON.stringify(data), header)
    },
    DashboardSearch(data) {
        return axios.post(master + "notification/DashboardSearch ", JSON.stringify(data), header)
    },
    HoardingTypeList(data) {
        return axios.post(master + "notification/HoardingTypeList ", JSON.stringify(data), header)
    },
    NewApplicationList(data) {
        return axios.post(master + "notification/AdminNewApplicationList ", JSON.stringify(data), header)
    },
    ApprovalAccess(data) {
        return axios.post(master + "notification/ApprovalAccess ", JSON.stringify(data), header)
    },
    //Admin user master
    adminuserlist(data) {
        return axios.post(master + "user/AdminUserList", JSON.stringify(data), header)
    },
    admineditusermaster(data) {
        return axios.post(master + "user/AdminEditUser", JSON.stringify(data), header)
    },
    adminaddusermaster(data) {
        return axios.post(master + "user/AdminAddUser", JSON.stringify(data), header)
    },
    admindeleteusermaster(data) {
        return axios.post(master + "user/AdminDeleteUser", JSON.stringify(data), header)
    },
    roleIDlist(data) {
        return axios.post(master + "user/UserRoleDropdown", JSON.stringify(data), header)
    },
    upload_to_AWS(data) {
        return axios.post(admin + 'getSignedUrlsgb/getSignedURL', JSON.stringify(data), {
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    // Complaints API -----------------------------
    ticketlist(data) {
        return axios.post(admin + "complaint/ticketlist", JSON.stringify(data), header)
    },
    deleteTicket(data) {
        return axios.post(admin + "complaint/deleteTicket", JSON.stringify(data), header)
    },
    getclientist(data) {
        return axios.post(admin + "complaint/getclientist", JSON.stringify(data), header)
    },
    TicketStatusMaster(data) {
        return axios.post(admin + "complaint/getTicketStatusMaster", JSON.stringify(data), header)
    },
    agentListDropdown(data) {
        return axios.post(admin + "complaint/agentListDropdown", JSON.stringify(data), header)
    },
    getTicketSource(data) {
        return axios.post(admin + "complaint/getTicketSource", JSON.stringify(data), header)
    },
    TicketCategoryMaster(data) {
        return axios.post(admin + "complaint/getTicketCategoryMaster", JSON.stringify(data), header)
    },
    updateTicketStatus(data) {
        return axios.post(admin + "complaint/updateticketstatus", JSON.stringify(data), header)
    },
    assignAgent(data) {
        return axios.post(admin + "complaint/assignAgent", JSON.stringify(data), header)
    },
    categoryListmaster(data) {
        return axios.post(admin + "complaint/categoryListmaster", JSON.stringify(data), header)
    },
    categoryAddEdit(data) {
        return axios.post(admin + "complaint/categoryAddEdit", JSON.stringify(data), header)
    },
    deleteCategory(data) {
        return axios.post(admin + "complaint/deleteCategory", JSON.stringify(data), header)
    },
    getticketDetails(data)
    {
        return axios.post(admin+"complaint/ticketDetails", JSON.stringify(data),  header)
    },
    getApplicationDetailsbyID(data)
    {
        return axios.post(admin+"scheme/getApplicationDetailsbyID", JSON.stringify(data),  header)
    },
    bannerlist(data) {
        return axios.post(master + "banner/BannerApplicationList  ", JSON.stringify(data), header)
    },
    AddBanner(data) {
        return axios.post(master + "banner/AddBanner", JSON.stringify(data), header)
    },
    EditBanner(data) {
        return axios.post(master + "banner/EditBanner", JSON.stringify(data), header)
    },
    BannerDelete(data) {
        return axios.post(master + "banner/BannerDelete", JSON.stringify(data), header)
    },
    passwordreset(data){
        return axios.post(track_api + "otp/resetPassword", JSON.stringify(data), header)
    },

    ProfileEdit(data) {
        return axios.post(track_api + "otp/ProfileEdit", JSON.stringify(data), header)
       
      },
    // upload_to_AWS(data)
    // {
    //      return axios.post(admin+"getSignedUrlsgb/getSignedURL", JSON.stringify(data),  header);
    // },

}
